import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import TextField from '../../../components/common/TextField';
import Button from '../../../components/common/Button';
import { getAlertMessageFunction } from '../../../common/Util';
import { resetOriginalAddressList, setAddress } from '../myInfoSlice';

const Content = ({ activeTab, onClose, onLoadMore }) => {
  const { t } = useTranslation('myInfo');

  const dispatch = useDispatch();
  const detailAddressRef = useRef();
  const { originalAddressList } = useSelector(state => state.myInfo);
  const [addressList, setAddressList] = useState(null);
  const [addressInput, setAddressInput] = useState({
    selectedAddress: '',
    detailAddress: '',
  });
  const observerRef = useRef();
  const containerRef = useRef();
  const handleObserver = useCallback(
    entries => {
      const target = entries[0];
      if (target.isIntersecting && addressList?.length > 0) {
        onLoadMore();
      }
    },
    [onLoadMore, addressList],
  );

  useEffect(() => {
    if (originalAddressList) {
      const newAddressList = createAddressList();
      setAddressList(newAddressList);
    }
  }, [originalAddressList]);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '20px',
      threshold: 0,
    };

    observerRef.current = new IntersectionObserver(handleObserver, options);

    if (containerRef.current) {
      observerRef.current.observe(containerRef.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [handleObserver]);

  const createAddressList = () => {
    const data = [];

    originalAddressList.map(item => {
      let buildingname = '';
      if (item[15] != null && item[15] !== '') {
        buildingname = `, ${item[15]}`;
      }

      let bungi = item[13];
      if (item[14] !== '0') {
        bungi += `-${item[14]}`;
      }

      let gunmul = item[16];
      if (item[17] !== '0') {
        gunmul += `-${item[17]}`;
      }

      let ri = '';
      if (item[18]) {
        ri = `${item[18]} `;
      }

      const addressData = {
        doro: `${item[5]} ${item[7]} ${item[2]} ${gunmul}(${item[9]}${buildingname})`,
        jibun: `${item[5]} ${item[7]} ${item[9]} ${ri}${bungi}${buildingname}`,
      };

      data.push(addressData);
    });

    return data;
  };

  const handleAddressChange = (value, type) => {
    if (type === 'selectedAddress') {
      setAddressInput({
        ...addressInput,
        selectedAddress: activeTab == '0' ? value.doro : activeTab == '1' ? value.jibun : '',
      });
      // 추가: 상세주소 입력 필드로 포커스
      detailAddressRef.current?.focus();
      return;
    }

    setAddressInput({
      ...addressInput,
      [type]: value,
    });
  };

  const handleSave = () => {
    const alertMessage = getAlertMessageFunction();
    if (!addressInput.selectedAddress || !addressInput.detailAddress) {
      alertMessage(t('address.alertMessage01'));
      return;
    }

    dispatch(setAddress(addressInput.selectedAddress + ' ' + addressInput.detailAddress));
    setAddressList(null);
    setAddressInput({
      selectedAddress: '',
      detailAddress: '',
    });
    onClose();
  };

  if (!addressList || addressList.length === 0) return null;

  return (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      <div
        style={{
          maxHeight: 'calc(100vh - 250px)',
          overflowY: 'auto',
          padding: '8px',
        }}>
        {addressList &&
          addressList.map((item, index) => {
            return (
              <div
                key={index}
                className="addressItem"
                onClick={() => handleAddressChange(item, 'selectedAddress')}>
                <div className="displayFlex" style={{ alignItems: 'stretch' }}>
                  <div className="itemTitle captionMedium">도로명</div>
                  <div className="captionMedium" style={{ flex: 1 }}>
                    {item.doro}
                  </div>
                </div>
                <div className="displayFlex" style={{ alignItems: 'stretch' }}>
                  <div className="itemTitle captionMedium">지번명</div>
                  <div className="captionMedium" style={{ flex: 1 }}>
                    {item.jibun}
                  </div>
                </div>
              </div>
            );
          })}
        {addressList?.length >= 10 && <div ref={containerRef} style={{ height: '50px' }} />}
      </div>
      <div className="displayFlexColumn" style={{ gap: '8px', margin: '16px 0px' }}>
        <TextField disabled value={addressInput.selectedAddress} />
        {/* 상세주소 입력 */}
        <TextField
          useRef={detailAddressRef}
          placeholder={t('address.detailAddressPlaceholder')}
          value={addressInput.detailAddress}
          onChange={e => handleAddressChange(e.target.value, 'detailAddress')}
        />
      </div>
      <Button value={t('address.save')} onClick={handleSave} fullWidth size="large" />
    </div>
  );
};

export default Content;
